import * as React from 'react';

import { cn } from '@epoch-ui/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'tw-flex tw-h-[48px] tw-w-full tw-rounded-xl tw-border-[1.5px] tw-border-solid tw-border-border-grey tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-ring-offset-background file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-font-normal placeholder:tw-text-medium-grey focus-visible:tw-border-primary-blue focus-visible:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50',
          error && 'tw-border-destructive-foreground',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
